module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/fbjs/~/core-js/library/modules/$.library.js
// module id = 480
// module chunks = 0